export const LineItemType = Object.freeze({
  ticket: 'ticket',
});

export interface CreateLineItemParams {
  type: typeof LineItemType;
  id: string;
  name: string;
  description: string | null;
  unitPrice: number;
  quantity: number;
  bulkDiscountAmount?: number;
  couponDiscountAmount?: number;
  appliedCoupon?: Record<string, any> | null;
  appliedBulkDiscountRule?: Record<string, any> | null;
  currency: string;
  taxRate?: number;
}

export interface LineItem {
  type: typeof LineItemType;
  id: string;
  name: string;
  description: string | null;
  unitPrice: number;
  quantity: number;
  appliedCoupon?: Record<string, any> | null;
  appliedBulkDiscountRule?: Record<string, any> | null;
  taxRate?: number;
  taxAmount?: number;
  subtotal: number;
  bulkDiscountAmount?: number;
  couponDiscountAmount?: number;
  totalDiscountAmount: number; // bulk discount + coupon discount
  total: number; // final amount customer pays for this line (after discount + tax) before order level discounts and coupons
  currency: string;
}

export function createCartLineItem(params: CreateLineItemParams): LineItem {
  const {
    type,
    id,
    name,
    description,
    unitPrice,
    quantity,
    bulkDiscountAmount = 0,
    couponDiscountAmount = 0,
    appliedCoupon = null,
    appliedBulkDiscountRule = null,
    taxRate = 0,
    currency,
  } = params;

  const subtotal = quantity * unitPrice;
  const totalDiscountAmount = bulkDiscountAmount + couponDiscountAmount;
  const taxableAmount = subtotal - totalDiscountAmount;
  const taxAmount = taxableAmount > 0 ? taxableAmount * taxRate : 0;
  const total = taxableAmount + taxAmount;

  return {
    type,
    id,
    name,
    description,

    quantity,
    unitPrice,
    subtotal,

    bulkDiscountAmount,
    couponDiscountAmount,
    totalDiscountAmount,

    taxRate,
    taxAmount,

    total,

    currency,

    appliedCoupon: appliedCoupon ?? null,
    appliedBulkDiscountRule: appliedBulkDiscountRule ?? null,
  };
}
